import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';
import {
  homePathForAccessRole,
  ORGANIZATION_STATUS,
  useMeAccess,
  useRefreshMeAccess,
  type AccessRole,
} from '@services/access';

/**
 * The only place a changed access role moves the person to their new home.
 * The first answer does not redirect, so a deep link survives a reload.
 */
export function AccessRoleSync() {
  const { role, isLoading, organization } = useMeAccess();
  const refresh = useRefreshMeAccess();
  const [location, setLocation] = useLocation();
  const previous = useRef<AccessRole | null>(null);

  useEffect(() => {
    if (isLoading) return;
    const prev = previous.current;
    previous.current = role;
    if (prev && prev !== role) {
      setLocation(homePathForAccessRole(role));
    }
  }, [role, isLoading, setLocation]);

  // A suspended org can be reactivated at any time; re-ask on every route change
  // while the block is shown so the unlock is not delayed by the stale time.
  const suspended = organization?.status === ORGANIZATION_STATUS.SUSPENDED;
  useEffect(() => {
    if (suspended) void refresh();
  }, [location, suspended, refresh]);

  return null;
}
